import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { EmployeeCompensation } from "./types";

export const employeeCompensationDetailService = (params: {
  id?: string;
  employeeId?: number;
}) =>
  RestAPIClient.call<EmployeeCompensation>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail,
    config: {
      requireAuthentication: true,
      params,
    },
  });
